export default __webpack_public_path__ + "static/B0215-8324934c1e42e59cf5222c186d2e4b56.png";